import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-kpi-card',
  standalone: true,
  imports: [CommonModule, TooltipModule],
  template: `
    <div class="kpi-card" 
         [ngStyle]="{'background': color}" 
         [ngClass]="{'kpi-dark-bg': isDarkBackground()}"
         [pTooltip]="getTooltipText()"
         tooltipPosition="top"
         appendTo="body"
         [showDelay]="500"
         [hideDelay]="0"
         [tooltipStyleClass]="'custom-tooltip'">
      <div class="kpi-icon">
        <i [ngClass]="icon"></i>
      </div>
      <div class="kpi-content">
        <div class="kpi-title">{{ title }}</div>
        <div class="kpi-value">{{ value }}</div>
      </div>
    </div>
  `,
  styleUrls: ['./kpi-card.component.scss']
})
export class KpiCardComponent {
  @Input() title: string = '';
  @Input() value: string | number = '';
  @Input() icon: string = '';
  @Input() color: string = '#fff';

  isDarkBackground(): boolean {
    return this.color === '#1f2842';
  }

  getTooltipText(): string {
    switch (this.title) {
      case 'NFS-e no mês':
        return 'Quantidade total de Notas Fiscais de Serviço Eletrônicas (NFS-e) emitidas e importadas no mês atual';
      
      case 'Extratos Importados (últimos 3 meses)':
        return 'Quantidade de extratos bancários importados nos últimos 3 meses, incluindo o número total de linhas de transações';
      
      case 'Valor Total Entradas Extratos (últimos 3 meses)':
        return 'Soma de todos os valores positivos (entradas) dos extratos bancários importados nos últimos 3 meses';
      
      case 'Valor Total Saídas Extratos (últimos 3 meses)':
        return 'Soma de todos os valores negativos (saídas) dos extratos bancários importados nos últimos 3 meses';
      
      default:
        return this.title;
    }
  }
} 